import { __decorate, __awaiter } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { BaseService, PasswordValidator, DocumentValidator, DateValidator, MatchValidator, UfService, ErrorMessageService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { ConfigService, SpeNOpenAccountProxy, SpeNUserAccountProxy, SpeViewNUserAccountProxy, SpeNPrizeDrawProxy, SpeExtUsersProxy, SpeViewNPrizeDrawProxy, SpeViewNAccountProxy, TypeEmailEnum, TypeTemplateEnum, SpeJNotificationProxy, SpeJOrderCommerce, UiPxPrizeDrawModule } from '@wlp/ui-px-prizedraw';
import { BehaviorSubject } from 'rxjs';

class PrizeDrawRegisterResponse {
}

class PrizeDrawPassWordResponse {
}

class PrizeDrawAddressResponse {
}

class PrizeDrawSignupResponse {
}

class ItemPayment {
}
class CustomData {
}
class PaymentResponse {
}

class Recurrent {
}

let LoginService = class LoginService extends BaseService {
    constructor(formBuilder, storage, configService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.storage = storage;
        this.configService = configService;
        this.errorMessagesLogin = {
            user: [
                {
                    type: 'required',
                    message: 'PRIZE_DRAW.LOGIN.INPUT.LOGIN_USER.MESSAGE.REQUIRED',
                },
                {
                    type: 'hasEmptySpace',
                    message: 'PRIZE_DRAW.LOGIN.INPUT.LOGIN_USER.MESSAGE.HAS_EMPTY_SPACE',
                },
                {
                    type: 'invalid',
                    message: 'PRIZE_DRAW.LOGIN.INPUT.LOGIN_USER.MESSAGE.INVALID',
                },
            ],
            password: [
                {
                    type: 'required',
                    message: 'PRIZE_DRAW.LOGIN.INPUT.LOGIN_PASSWORD.MESSAGE.REQUIRED',
                },
                {
                    type: 'pattern',
                    message: 'PRIZE_DRAW.LOGIN.INPUT.LOGIN_PASSWORD.MESSAGE.EXACT_NUMBER_CHAR',
                    param: { exactNumberChar: 4 },
                },
                {
                    type: 'invalid',
                    message: 'PRIZE_DRAW.LOGIN.INPUT.LOGIN_PASSWORD.MESSAGE.INVALID',
                },
            ],
        };
        this.errorMessagesForgotPassword = {
            user: [
                {
                    type: 'required',
                    message: 'PRIZE_DRAW.LOGIN.INPUT.LOGIN_USER.MESSAGE.REQUIRED',
                },
                {
                    type: 'hasEmptySpace',
                    message: 'PRIZE_DRAW.LOGIN.INPUT.LOGIN_USER.MESSAGE.HAS_EMPTY_SPACE',
                },
                {
                    type: 'invalid',
                    message: 'PRIZE_DRAW.LOGIN.INPUT.LOGIN_USER.MESSAGE.INVALID',
                },
            ],
        };
    }
    getFormPrizeDrawLogin() {
        this.formPrizeDrawLogin = this.formBuilder.group({
            user: new FormControl('', Validators.compose([
                Validators.required,
                PasswordValidator.hasEmptySpace,
                Validators.minLength(6),
                Validators.maxLength(100),
            ])),
            password: new FormControl('', Validators.compose([Validators.required, Validators.pattern('[0-9]{4}')])),
        });
        return this.formPrizeDrawLogin;
    }
    getFormMessageLogin() {
        return this.errorMessagesLogin;
    }
    getFormPrizeDrawForgotPassword() {
        this.formPrizeDrawForgotPassword = this.formBuilder.group({
            user: new FormControl('', Validators.compose([
                Validators.required,
                PasswordValidator.hasEmptySpace,
                Validators.minLength(6),
                Validators.maxLength(100),
            ])),
        });
        return this.formPrizeDrawForgotPassword;
    }
    getFormMessageForgotPassword() {
        return this.errorMessagesForgotPassword;
    }
};
LoginService.ctorParameters = () => [
    { type: FormBuilder },
    { type: Storage },
    { type: ConfigService }
];
LoginService = __decorate([
    Injectable()
], LoginService);

class PrizeDrawAccountResponse {
}

var TypeFlowEnum;
(function (TypeFlowEnum) {
    TypeFlowEnum["PRIZE_DRAW"] = "PRIZE_DRAW";
    TypeFlowEnum["CLUB_NSC"] = "CLUB_NSC";
})(TypeFlowEnum || (TypeFlowEnum = {}));

var TypeUserEnum;
(function (TypeUserEnum) {
    TypeUserEnum["DEFAULT"] = "DEFAULT";
    TypeUserEnum["FREEMIUM"] = "FREEMIUM";
    TypeUserEnum["FREEMIUM_CP"] = "FREEMIUM_CP";
    TypeUserEnum["PREMIUM"] = "PREMIUM";
    TypeUserEnum["PREMIUM_CP"] = "PREMIUM_CP";
    TypeUserEnum["PARTNER"] = "PARTNER";
})(TypeUserEnum || (TypeUserEnum = {}));

var StatusPreAccountEnum;
(function (StatusPreAccountEnum) {
    StatusPreAccountEnum["IN_ONBOARDING"] = "IN_ONBOARDING";
    StatusPreAccountEnum["IN_ANALYSIS"] = "IN_ANALYSIS";
    StatusPreAccountEnum["APPROVED"] = "APPROVED";
    StatusPreAccountEnum["REPROVED"] = "REPROVED";
    StatusPreAccountEnum["RETURNED"] = "RETURNED";
})(StatusPreAccountEnum || (StatusPreAccountEnum = {}));

let RegisterService = class RegisterService extends BaseService {
    constructor(speNOpenAccountProxy, speNUserAccountProxy, speViewNUserAccountProxy, formBuilder, ufService, storage, configService, errorMessageService) {
        super(storage, configService);
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speNUserAccountProxy = speNUserAccountProxy;
        this.speViewNUserAccountProxy = speViewNUserAccountProxy;
        this.formBuilder = formBuilder;
        this.ufService = ufService;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorMessagesRegister = {
            userName: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER.INPUT.USER.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.PATTERN' },
                { type: 'redundant', message: 'PRIZE_DRAW.REGISTER.INPUT.USER.MESSAGE.REDUNDANT' },
            ],
            fullName: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER.INPUT.FULLNAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 },
                },
                { type: 'pattern', message: 'PRIZE_DRAW.REGISTER.INPUT.FULLNAME.MESSAGE.PATTERN' },
            ],
            cpf: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER.INPUT.CPF.MESSAGE.REQUIRED' },
                { type: 'cpfNotValid', message: 'PRIZE_DRAW.REGISTER.INPUT.CPF.MESSAGE.CPF_NOT_VALID' },
                { type: 'redundant', message: 'PRIZE_DRAW.REGISTER.INPUT.CPF.MESSAGE.REDUNDANT' },
            ],
            email: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.PATTERN' },
                { type: 'email', message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.EMAIL_INVALID' },
                { type: 'redundant', message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.REDUNDANT' },
            ],
            birthDate: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER.INPUT.BIRTHDATE.MESSAGE.REQUIRED' },
                { type: 'validDate', message: 'PRIZE_DRAW.REGISTER.INPUT.BIRTHDATE.MESSAGE.UNDER_18' },
                { type: 'ptDate', message: 'PRIZE_DRAW.REGISTER.INPUT.BIRTHDATE.MESSAGE.DATE_NOT_VALID' },
            ],
            cellphone: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER.INPUT.CELLPHONE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.CELLPHONE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 14 },
                },
                {
                    type: 'maxlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.CELLPHONE.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 15 },
                },
            ],
        };
        this.errorMessagesRegisterAddress = {
            zipCode: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.ZIPCODE.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.ZIPCODE.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 9 },
                },
                {
                    type: 'minlength',
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.ZIPCODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 8 },
                },
                { type: 'pattern', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.ZIPCODE.MESSAGE.PATTERN' },
            ],
            street: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.STREET.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    param: { minLength: 4 },
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.STREET.MESSAGE.MIN_LENGTH',
                },
                {
                    type: 'maxlength',
                    param: { maxLength: 200 },
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.STREET.MESSAGE.MAX_LENGTH',
                },
            ],
            streetNumber: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.STREET_NUMBER.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    param: { maxLength: 30 },
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.STREET_NUMBER.MESSAGE.MAX_LENGTH',
                },
            ],
            streetComplement: [
                {
                    type: 'maxlength',
                    param: { maxLength: 100 },
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.STREET_COMPLEMENT.MESSAGE.MAX_LENGTH',
                },
            ],
            neighborhood: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.NEIGHBORHOOD.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    param: { minLength: 2 },
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.NEIGHBORHOOD.MESSAGE.MIN_LENGTH',
                },
                {
                    type: 'maxlength',
                    param: { maxLength: 60 },
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.NEIGHBORHOOD.MESSAGE.MAX_LENGTH',
                },
            ],
            city: [{ type: 'required', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.CITY.MESSAGE.REQUIRED' }],
            uf: [{ type: 'required', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.UF.MESSAGE.REQUIRED' }],
        };
        // private errorMessagesRegisterPassword = {
        //   password: [
        //     { type: 'required', message: 'PRIZE_DRAW.REGISTER_PASSWORD.INPUT.PASSWORD.MESSAGE.REQUIRED' },
        //     {
        //       type: 'minChar',
        //       message: 'PRIZE_DRAW.REGISTER_PASSWORD.INPUT.PASSWORD.MESSAGE.MIN_CHAR',
        //       param: { minChar: 8 },
        //     },
        //     {
        //       type: 'minSpecialChar',
        //       message: 'PRIZE_DRAW.REGISTER_PASSWORD.INPUT.PASSWORD.MESSAGE.MIN_SPECIAL_CHAR',
        //       param: { minSpecialChar: 1 },
        //     },
        //     {
        //       type: 'minNumberChar',
        //       message: 'PRIZE_DRAW.REGISTER_PASSWORD.INPUT.PASSWORD.MESSAGE.MIN_NUMBER_CHAR',
        //       param: { minNumberChar: 1 },
        //     },
        //     {
        //       type: 'minUpperChar',
        //       message: 'PRIZE_DRAW.REGISTER_PASSWORD.INPUT.PASSWORD.MESSAGE.MIN_UPPER_CHAR',
        //       param: { minUpperChar: 1 },
        //     },
        //     {
        //       type: 'minLowerChar',
        //       message: 'PRIZE_DRAW.REGISTER_PASSWORD.INPUT.PASSWORD.MESSAGE.MIN_LOWER_CHAR',
        //       param: { minLowerChar: 1 },
        //     },
        //     { type: 'hasEmptySpace', message: 'PRIZE_DRAW.REGISTER_PASSWORD.INPUT.PASSWORD.MESSAGE.HAS_EMPTY_SPACE' },
        //   ],
        //   confirmPassword: [
        //     { type: 'mustMatch', message: 'PRIZE_DRAW.REGISTER_PASSWORD.INPUT.CONFIRM_PASSWORD.MESSAGE.MUST_MATCH' },
        //   ],
        // };
        this.errorMessagesRegisterPassword = {
            password: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER_PASSWORD.INPUT.PASSWORD.MESSAGE.REQUIRED' },
                {
                    type: 'pattern',
                    message: 'PRIZE_DRAW.REGISTER_PASSWORD.INPUT.PASSWORD.MESSAGE.EXACT_NUMBER_CHAR',
                    param: { exactNumberChar: 4 },
                },
                { type: 'hasEmptySpace', message: 'PRIZE_DRAW.REGISTER_PASSWORD.INPUT.PASSWORD.MESSAGE.HAS_EMPTY_SPACE' },
            ],
            confirmPassword: [
                { type: 'mustMatch', message: 'PRIZE_DRAW.REGISTER_PASSWORD.INPUT.CONFIRM_PASSWORD.MESSAGE.MUST_MATCH' },
            ],
        };
        this.accountBody = new BehaviorSubject(null);
    }
    getFormMessageRegister() {
        return this.errorMessagesRegister;
    }
    getFormMessageRegisterAddress() {
        return this.errorMessagesRegisterAddress;
    }
    getFormMessageRegisterPassword() {
        return this.errorMessagesRegisterPassword;
    }
    getAccountBody() {
        return this.accountBody.asObservable();
    }
    getFormPrizeDrawRegister() {
        this.formPrizeDrawRegister = this.formBuilder.group({
            fullName: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
                Validators.pattern("[a-zA-ZÀ-Úà-ú]+(([' ][a-zA-ZÀ-Úà-ú ])?[a-zA-ZÀ-Úà-ú]*)*"),
            ])),
            cpf: new FormControl('', Validators.compose([DocumentValidator.isValidCPF, Validators.required])),
            birthDate: new FormControl('', Validators.compose([Validators.required, DateValidator.ptDate, DateValidator.validDate])),
            cellphone: new FormControl('', Validators.compose([Validators.required, Validators.minLength(14), Validators.maxLength(15)])),
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
                Validators.email,
                Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,5}'),
            ])),
        });
        return this.formPrizeDrawRegister;
    }
    saveStep1(form, accountData) {
        const accountBody = new PrizeDrawAccountResponse();
        const data = form.getRawValue();
        if (accountData) {
            accountBody._id = accountData._id;
            accountBody.uuidAccountPayment = accountData.uuidAccountPayment;
            accountBody.uuidWhiteLabel = accountData.uuidWhiteLabel;
            accountBody.uuidUserSSO = accountData.uuidUserSSO;
            accountBody.userName = accountData.userName;
            accountBody.fullName = data.fullName;
            accountBody.document = data.cpf;
            accountBody.email = data.email;
            accountBody.dateBirth = data.birthDate;
            accountBody.cellPhone = data.cellphone;
            accountBody.address = accountData.address;
            accountBody.typeUser = accountData.typeUser;
            accountBody.password = accountData.password;
            accountBody.acceptTherms = accountData.acceptTherms;
            accountBody.dateAcceptTherms = accountData.dateAcceptTherms;
            accountBody.acceptReceiveComunication = accountData.acceptReceiveComunication;
            accountBody.dateAcceptReceiveComunication = accountData.dateAcceptReceiveComunication;
            accountBody.acceptReceiveOffers = accountData.acceptReceiveOffers;
            accountBody.dateAcceptReceiveOffers = accountData.dateAcceptReceiveOffers;
            accountBody.status = accountData.status;
            accountBody.dateRegister = accountData.dateRegister;
            accountBody.dateUpdated = accountData.dateUpdated;
            accountBody.onboardingCanceled = accountData.onboardingCanceled;
            accountBody.deleted = accountData.deleted;
            accountBody.analysis = accountData.analysis;
            accountBody.typeFlow = accountData.typeFlow;
            accountBody.migrationWlp = accountData.migrationWlp;
        }
        else {
            accountBody.userName = data.email;
            accountBody.fullName = data.fullName;
            accountBody.document = data.cpf;
            accountBody.email = data.email;
            accountBody.dateBirth = data.birthDate;
            accountBody.cellPhone = data.cellphone;
        }
        this.accountBody.next(accountBody);
    }
    verificationDocument(uuidWhiteLabel, document) {
        return __awaiter(this, void 0, void 0, function* () {
            let dataAccount;
            yield this.speViewNUserAccountProxy
                .verificationDocument(uuidWhiteLabel, String(document).replace(/[^\w\s]/gi, ''))
                .toPromise()
                .then((res) => {
                dataAccount = res;
            })
                .catch((err) => console.error(err));
            let exist = !!dataAccount ? dataAccount : null;
            return Promise.resolve(exist);
        });
    }
    verificationEmail(uuidWhiteLabel, email) {
        return __awaiter(this, void 0, void 0, function* () {
            let dataAccount;
            yield this.speViewNUserAccountProxy
                .verificationEmail(uuidWhiteLabel, email)
                .toPromise()
                .then((res) => {
                dataAccount = res;
            })
                .catch((err) => console.error(err));
            let exist = !!dataAccount ? dataAccount : null;
            return Promise.resolve(exist);
        });
    }
    verificationUserName(uuidWhiteLabel, userName) {
        return __awaiter(this, void 0, void 0, function* () {
            let dataAccount;
            yield this.speViewNUserAccountProxy
                .verificationUserName(uuidWhiteLabel, userName)
                .toPromise()
                .then((res) => {
                dataAccount = res;
            })
                .catch((err) => console.error(err));
            let exist = !!dataAccount ? dataAccount : null;
            return Promise.resolve(exist);
        });
    }
    getFormPrizeDrawRegisterAddress() {
        this.formPrizeDrawRegisterAddress = this.formBuilder.group({
            zipCode: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(9),
                Validators.pattern('^[a-zA-Z0-9_.+-]+$'),
            ])),
            street: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(200)])),
            streetNumber: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, Validators.maxLength(30)])),
            streetComplement: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.maxLength(60)])),
            neighborhood: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(60)])),
            city: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(30)])),
            uf: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, Validators.minLength(2)])),
        });
        return this.formPrizeDrawRegisterAddress;
    }
    saveStep2(form) {
        let personalData;
        this.getAccountBody().subscribe((res) => {
            personalData = res;
        });
        this.accountBody.next(this.setAddressData(form, personalData));
    }
    setAddressData(form, personalData) {
        const accountBody = new PrizeDrawAccountResponse();
        const data = form.getRawValue();
        if (personalData._id) {
            accountBody._id = personalData._id;
            accountBody.uuidAccountPayment = personalData.uuidAccountPayment;
            accountBody.uuidWhiteLabel = personalData.uuidWhiteLabel;
            accountBody.uuidUserSSO = personalData.uuidUserSSO;
            accountBody.userName = personalData.userName;
            accountBody.fullName = personalData.fullName;
            accountBody.document = personalData.document;
            accountBody.email = personalData.email;
            accountBody.dateBirth = personalData.dateBirth;
            accountBody.cellPhone = personalData.cellPhone;
            accountBody.address = {
                zipcode: data.zipCode,
                street: data.street,
                streetNumber: data.streetNumber,
                streetComplement: data.streetComplement,
                neighborhood: data.neighborhood,
                city: data.city,
                uf: data.uf,
                country: 'BR',
            };
            accountBody.typeUser = personalData.typeUser;
            accountBody.password = personalData.password;
            accountBody.acceptTherms = personalData.acceptTherms;
            accountBody.dateAcceptTherms = personalData.dateAcceptTherms;
            accountBody.acceptReceiveComunication = personalData.acceptReceiveComunication;
            accountBody.dateAcceptReceiveComunication = personalData.dateAcceptReceiveComunication;
            accountBody.acceptReceiveOffers = personalData.acceptReceiveOffers;
            accountBody.dateAcceptReceiveOffers = personalData.dateAcceptReceiveOffers;
            accountBody.status = personalData.status;
            accountBody.dateRegister = personalData.dateRegister;
            accountBody.dateUpdated = personalData.dateUpdated;
            accountBody.onboardingCanceled = personalData.onboardingCanceled;
            accountBody.deleted = personalData.deleted;
            accountBody.analysis = personalData.analysis;
            accountBody.typeFlow = personalData.typeFlow;
            accountBody.migrationWlp = personalData.migrationWlp;
        }
        else {
            accountBody.userName = personalData.userName;
            accountBody.fullName = personalData.fullName;
            accountBody.document = personalData.document;
            accountBody.email = personalData.email;
            accountBody.dateBirth = personalData.dateBirth;
            accountBody.status = StatusPreAccountEnum.IN_ONBOARDING;
            accountBody.cellPhone = personalData.cellPhone;
            accountBody.address = {
                zipcode: data.zipCode,
                street: data.street,
                streetNumber: data.streetNumber,
                streetComplement: data.streetComplement,
                neighborhood: data.neighborhood,
                city: data.city,
                uf: data.uf,
                country: 'BR',
            };
        }
        return accountBody;
    }
    searchPostalCode(zipcode) {
        this.resetAddress();
        return this.speNOpenAccountProxy.getCep(zipcode);
    }
    getUf() {
        return this.ufService.getListUf();
    }
    updateAddress(address) {
        if (!address.logradouro || address.logradouro === '') {
            this.formPrizeDrawRegisterAddress.controls['street'].enable();
        }
        if (!address.bairro || address.bairro === '') {
            this.formPrizeDrawRegisterAddress.controls['neighborhood'].enable();
        }
        this.formPrizeDrawRegisterAddress.controls['streetNumber'].enable();
        this.formPrizeDrawRegisterAddress.controls['streetComplement'].enable();
        this.formPrizeDrawRegisterAddress.patchValue({
            zipcode: address.cep,
            street: address.logradouro.toUpperCase(),
            streetNumber: address.numero,
            streetComplement: address.complemento,
            neighborhood: address.bairro.toUpperCase(),
            city: address.localidade.toUpperCase(),
            uf: address.uf.toUpperCase(),
            country: 'BR'.toUpperCase(),
        });
    }
    resetAddress() {
        this.formPrizeDrawRegisterAddress.controls['street'].disable();
        this.formPrizeDrawRegisterAddress.controls['neighborhood'].disable();
        this.formPrizeDrawRegisterAddress.controls['streetNumber'].disable();
        this.formPrizeDrawRegisterAddress.controls['streetComplement'].disable();
        this.formPrizeDrawRegisterAddress.patchValue({
            street: '',
            neighborhood: '',
            city: '',
            uf: '',
            streetNumber: '',
            streetComplement: '',
            country: '',
        });
    }
    getFormPrizeDrawPassword() {
        this.formPrizeDrawPassword = this.formBuilder.group({
            password: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(4), Validators.pattern('[0-9]{4}')])),
            confirmPassword: new FormControl(''),
            acceptTherms: new FormControl(false),
            acceptReceiveComunication: new FormControl(true),
            acceptReceiveOffers: new FormControl(true),
        }, { validator: MatchValidator.mustMatch('password', 'confirmPassword') });
        return this.formPrizeDrawPassword;
    }
    saveStep3(form, uuidWhiteLabel) {
        let accountData;
        this.getAccountBody().subscribe((res) => {
            accountData = res;
        });
        return this.createAccount(this.setAccountData(form, accountData, uuidWhiteLabel));
    }
    updateAccountData(accountData) {
        this.accountBody.next(accountData);
    }
    setAccountData(form, accountData, uuidWhiteLabel) {
        const accountBody = new PrizeDrawAccountResponse();
        const data = form.getRawValue();
        if (accountData._id) {
            accountBody._id = accountData._id;
            accountBody.uuidAccountPayment = accountData.uuidAccountPayment;
            accountBody.uuidWhiteLabel = accountData.uuidWhiteLabel;
            accountBody.uuidUserSSO = accountData.uuidUserSSO;
            accountBody.userName = accountData.userName;
            accountBody.fullName = accountData.fullName;
            accountBody.document = String(accountData.document).replace(/[^\w\s]/gi, '');
            accountBody.email = accountData.email;
            accountBody.dateBirth = accountData.dateBirth;
            accountBody.cellPhone = String(accountData.cellPhone).replace(/[^\w\s]/gi, '');
            accountBody.address = accountData.address;
            accountBody.typeUser = accountData.typeUser;
            accountBody.password = data.password;
            accountBody.acceptTherms = data.acceptTherms;
            accountBody.dateAcceptTherms = new Date();
            accountBody.acceptReceiveComunication = data.acceptReceiveComunication;
            accountBody.dateAcceptReceiveComunication = new Date();
            accountBody.acceptReceiveOffers = data.acceptReceiveOffers;
            accountBody.dateAcceptReceiveOffers = new Date();
            accountBody.status = accountData.status;
            accountBody.dateUpdated = new Date();
            accountBody.onboardingCanceled = accountData.onboardingCanceled;
            accountBody.deleted = accountData.deleted;
            accountBody.analysis = accountData.analysis;
            accountBody.typeFlow = accountData.typeFlow;
            accountBody.migrationWlp = accountData.migrationWlp;
            accountBody.recurrent = accountData.recurrent;
        }
        else {
            accountBody.uuidWhiteLabel = uuidWhiteLabel;
            accountBody.userName = accountData.userName;
            accountBody.fullName = accountData.fullName;
            accountBody.document = String(accountData.document).replace(/[^\w\s]/gi, '');
            accountBody.email = accountData.email;
            accountBody.dateBirth = accountData.dateBirth;
            accountBody.cellPhone = String(accountData.cellPhone).replace(/[^\w\s]/gi, '');
            accountBody.address = accountData.address;
            accountBody.typeUser = TypeUserEnum.DEFAULT;
            accountBody.password = data.password;
            accountBody.acceptTherms = data.acceptTherms;
            accountBody.dateAcceptTherms = new Date();
            accountBody.acceptReceiveComunication = data.acceptReceiveComunication;
            accountBody.dateAcceptReceiveComunication = new Date();
            accountBody.acceptReceiveOffers = data.acceptReceiveOffers;
            accountBody.dateAcceptReceiveOffers = new Date();
            accountBody.status = StatusPreAccountEnum.IN_ONBOARDING;
            accountBody.onboardingCanceled = false;
            accountBody.deleted = false;
            accountBody.typeFlow = TypeFlowEnum.PRIZE_DRAW;
            accountBody.recurrent = {
                authorizeNow: true,
                startDate: new Date(),
                endDate: null,
                interval: 'WEEKLY',
                recurrentActive: true,
            };
        }
        return accountBody;
    }
    createAccount(accountBody) {
        if (!!accountBody._id) {
            return this.speNUserAccountProxy.updatePreAccount(accountBody._id, accountBody);
        }
        else {
            return this.speNUserAccountProxy.createPreAccount(accountBody);
        }
    }
    updateRecurrence(id, recurrent) {
        return this.speNUserAccountProxy.updateRecurrence(id, recurrent);
    }
    tryAgain(id) {
        return this.speNUserAccountProxy.tryAgain(id);
    }
    unsubscribe() {
        this.accountBody = new BehaviorSubject(null);
    }
};
RegisterService.ctorParameters = () => [
    { type: SpeNOpenAccountProxy },
    { type: SpeNUserAccountProxy },
    { type: SpeViewNUserAccountProxy },
    { type: FormBuilder },
    { type: UfService },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService }
];
RegisterService = __decorate([
    Injectable()
], RegisterService);

class PrizeDrawUserResponse {
}

class PasswordBodyResponse {
}

let ProfileService = class ProfileService extends BaseService {
    constructor(speNOpenAccountProxy, speNPrizeDrawProxy, speExtUsersProxy, speViewNPrizeDrawProxy, formBuilder, storage, ufService, configService, errorMessageService) {
        super(storage, configService);
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speNPrizeDrawProxy = speNPrizeDrawProxy;
        this.speExtUsersProxy = speExtUsersProxy;
        this.speViewNPrizeDrawProxy = speViewNPrizeDrawProxy;
        this.formBuilder = formBuilder;
        this.storage = storage;
        this.ufService = ufService;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorMessagesChangePassword = {
            currentPassword: [
                {
                    type: 'required',
                    message: 'PRIZE_DRAW.PROFILE.CHANGE_PASSWORD.INPUT.CURRENT_PASSWORD.MESSAGE.REQUIRED',
                },
                {
                    type: 'pattern',
                    message: 'PRIZE_DRAW.PROFILE.CHANGE_PASSWORD.INPUT.CURRENT_PASSWORD.MESSAGE.EXACT_NUMBER_CHAR',
                    param: { exactNumberChar: 4 },
                },
                {
                    type: 'maxlength',
                    message: 'PRIZE_DRAW.PROFILE.CHANGE_PASSWORD.INPUT.CURRENT_PASSWORD.MESSAGE.MAX_LENGTH',
                    param: {
                        maxLength: 30,
                    },
                },
                {
                    type: 'hasEmptySpace',
                    message: 'PRIZE_DRAW.PROFILE.CHANGE_PASSWORD.INPUT.CURRENT_PASSWORD.MESSAGE.HAS_EMPTY_SPACE',
                },
            ],
            newPassword: [
                { type: 'required', message: 'PRIZE_DRAW.PROFILE.CHANGE_PASSWORD.INPUT.NEW_PASSWORD.MESSAGE.REQUIRED' },
                {
                    type: 'pattern',
                    message: 'PRIZE_DRAW.PROFILE.CHANGE_PASSWORD.INPUT.NEW_PASSWORD.MESSAGE.EXACT_NUMBER_CHAR',
                    param: { exactNumberChar: 4 },
                },
                {
                    type: 'hasEmptySpace',
                    message: 'PRIZE_DRAW.PROFILE.CHANGE_PASSWORD.INPUT.NEW_PASSWORD.MESSAGE.HAS_EMPTY_SPACE',
                },
            ],
            confirmNewPassword: [
                { type: 'required', message: 'PRIZE_DRAW.PROFILE.CHANGE_PASSWORD.INPUT.CONFIRM_NEW_PASSWORD.MESSAGE.REQUIRED' },
                {
                    type: 'mustMatch',
                    message: 'PRIZE_DRAW.PROFILE.CHANGE_PASSWORD.INPUT.CONFIRM_NEW_PASSWORD.MESSAGE.MUST_MATCH',
                },
            ],
        };
        this.errorMessagesProfile = {
            fullName: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER.INPUT.FULLNAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 },
                },
            ],
            cpf: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER.INPUT.CPF.MESSAGE.REQUIRED' },
                { type: 'cpfNotValid', message: 'PRIZE_DRAW.REGISTER.INPUT.CPF.MESSAGE.CPF_NOT_VALID' },
                { type: 'redundant', message: 'PRIZE_DRAW.REGISTER.INPUT.CPF.MESSAGE.REDUNDANT' },
            ],
            email: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.PATTERN' },
                { type: 'email', message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.PATTERN' },
                { type: 'redundant', message: 'PRIZE_DRAW.REGISTER.INPUT.E-MAIL.MESSAGE.REDUNDANT' },
            ],
            birthDate: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER.INPUT.BIRTHDATE.MESSAGE.REQUIRED' },
                { type: 'validDate', message: 'PRIZE_DRAW.REGISTER.INPUT.BIRTHDATE.MESSAGE.DATE_NOT_VALID' },
            ],
            cellphone: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER.INPUT.CELLPHONE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.CELLPHONE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 14 },
                },
                {
                    type: 'maxlength',
                    message: 'PRIZE_DRAW.REGISTER.INPUT.CELLPHONE.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 15 },
                },
            ],
        };
        this.errorMessagesProfileAddress = {
            zipCode: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.ZIPCODE.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.ZIPCODE.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 9 },
                },
                {
                    type: 'minlength',
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.ZIPCODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 8 },
                },
                { type: 'pattern', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.ZIPCODE.MESSAGE.PATTERN' },
            ],
            street: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.STREET.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    param: { minLength: 5 },
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.STREET.MESSAGE.MIN_LENGTH',
                },
                {
                    type: 'maxlength',
                    param: { maxLength: 200 },
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.STREET.MESSAGE.MAX_LENGTH',
                },
            ],
            streetNumber: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.STREET_NUMBER.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    param: { maxLength: 30 },
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.STREET_NUMBER.MESSAGE.MAX_LENGTH',
                },
            ],
            streetComplement: [
                {
                    type: 'maxlength',
                    param: { maxLength: 100 },
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.STREET_COMPLEMENT.MESSAGE.MAX_LENGTH',
                },
            ],
            neighborhood: [
                { type: 'required', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.NEIGHBORHOOD.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    param: { minLength: 5 },
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.NEIGHBORHOOD.MESSAGE.MIN_LENGTH',
                },
                {
                    type: 'maxlength',
                    param: { maxLength: 60 },
                    message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.NEIGHBORHOOD.MESSAGE.MAX_LENGTH',
                },
            ],
            city: [{ type: 'required', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.CITY.MESSAGE.REQUIRED' }],
            uf: [{ type: 'required', message: 'PRIZE_DRAW.REGISTER_ADDRESS.INPUT.UF.MESSAGE.REQUIRED' }],
        };
    }
    getFormPrizeDrawChangePassword() {
        this.formPrizeDrawChangePassword = this.formBuilder.group({
            /*       currentPassword: new FormControl('', Validators.compose([
            Validators.required,
            PasswordValidator.hasEmptySpace,
            Validators.minLength(8),
            Validators.maxLength(30)
          ])), */
            newPassword: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(4), Validators.pattern('[0-9]{4}')])),
            confirmNewPassword: new FormControl(''),
        }, {
            validator: MatchValidator.mustMatch('newPassword', 'confirmNewPassword'),
        });
        return this.formPrizeDrawChangePassword;
    }
    getFormPrizeDrawProfile() {
        this.formPrizeDrawProfile = this.formBuilder.group({
            fullName: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(100)])),
            cpf: new FormControl('', Validators.compose([DocumentValidator.isValidCPF, Validators.required])),
            birthDate: new FormControl('', Validators.compose([Validators.required, DateValidator.ptDate, DateValidator.validDate])),
            cellphone: new FormControl('', Validators.compose([Validators.required, Validators.minLength(14), Validators.maxLength(15)])),
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
                Validators.email,
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}'),
            ])),
            zipCode: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(9),
                Validators.pattern('^[a-zA-Z0-9_.+-]+$'),
            ])),
            street: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(200)])),
            streetNumber: new FormControl({ value: '' }, Validators.compose([Validators.required, Validators.maxLength(30)])),
            streetComplement: new FormControl({ value: '' }, Validators.compose([Validators.maxLength(60)])),
            neighborhood: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(60)])),
            city: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(30)])),
            uf: new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, Validators.minLength(2)])),
        });
        return this.formPrizeDrawProfile;
    }
    getFormMessageChangePassword() {
        return this.errorMessagesChangePassword;
    }
    getFormMessageProfile() {
        return this.errorMessagesProfile;
    }
    getFormMessageProfileAddress() {
        return this.errorMessagesProfileAddress;
    }
    searchPostalCode(zipcode) {
        this.resetAddress();
        return this.speNOpenAccountProxy.getCep(zipcode);
    }
    getUf() {
        return this.ufService.getListUf();
    }
    findUserIdAndPromoUuid(uuidWhiteLabel, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findUserIdAndPromoUuid(uuidWhiteLabel, userId)
                .toPromise()
                .then((res) => {
                consultResponse = res[0];
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    updateAddress(address) {
        if (!address.logradouro || address.logradouro === '') {
            this.formPrizeDrawProfile.controls['street'].enable();
        }
        if (!address.bairro || address.bairro === '') {
            this.formPrizeDrawProfile.controls['neighborhood'].enable();
        }
        this.formPrizeDrawProfile.controls['streetNumber'].enable();
        this.formPrizeDrawProfile.controls['streetComplement'].enable();
        this.formPrizeDrawProfile.patchValue({
            zipcode: address.cep,
            street: address.logradouro.toUpperCase(),
            neighborhood: address.bairro.toUpperCase(),
            city: address.localidade.toUpperCase(),
            uf: address.uf.toUpperCase(),
            country: 'BR'.toUpperCase(),
        });
    }
    resetAddress() {
        this.formPrizeDrawProfile.controls['street'].disable();
        this.formPrizeDrawProfile.controls['neighborhood'].disable();
        this.formPrizeDrawProfile.controls['streetNumber'].disable();
        this.formPrizeDrawProfile.controls['streetComplement'].disable();
        this.formPrizeDrawProfile.patchValue({
            street: '',
            neighborhood: '',
            city: '',
            uf: '',
            streetNumber: '',
            streetComplement: '',
            country: '',
        });
    }
    saveData(form, user, uuidWhiteLabel) {
        return this.updateUserPromotion(uuidWhiteLabel, this.setData(form, user));
    }
    setData(form, user) {
        const accountBody = new PrizeDrawUserResponse();
        const data = form.getRawValue();
        accountBody.id = user.id;
        accountBody.name = user.name;
        accountBody.cpf = user.cpf;
        accountBody.birth = user.birth;
        accountBody.cel = data.cellphone.replace(/[^\w\s]/gi, '').replace(/\s+/, '');
        accountBody.email = user.email;
        accountBody.cep = data.zipCode.replace(/[^\w\s]/gi, '');
        accountBody.address = data.street;
        accountBody.number = data.streetNumber;
        accountBody.complement = data.streetComplement;
        accountBody.neighborhood = data.neighborhood;
        accountBody.city = data.city;
        accountBody.state = data.uf;
        accountBody.sex = user.sex;
        return accountBody;
    }
    updateUserPromotion(uuidWhiteLabel, prizeDrawUsers) {
        return this.speNPrizeDrawProxy.updateUser(uuidWhiteLabel, prizeDrawUsers);
    }
    savePassword(form, uuidWhiteLabel, email) {
        return this.updatePassword(this.setDataPassword(form, uuidWhiteLabel, email));
    }
    updatePassword(passwordBody) {
        return this.speExtUsersProxy.updatePassword(passwordBody);
    }
    deleteUser(uuidWhiteLabel, uuidAccountPayment, userId) {
        return this.speNPrizeDrawProxy.deleteUser(uuidWhiteLabel, uuidAccountPayment, userId);
    }
    setDataPassword(form, uuidWhiteLabel, email) {
        const passwordBody = new PasswordBodyResponse();
        passwordBody.uuidWl = uuidWhiteLabel;
        passwordBody.email = email;
        passwordBody.password = form.get('newPassword').value;
        return passwordBody;
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
};
ProfileService.ctorParameters = () => [
    { type: SpeNOpenAccountProxy },
    { type: SpeNPrizeDrawProxy },
    { type: SpeExtUsersProxy },
    { type: SpeViewNPrizeDrawProxy },
    { type: FormBuilder },
    { type: Storage },
    { type: UfService },
    { type: ConfigService },
    { type: ErrorMessageService }
];
ProfileService = __decorate([
    Injectable()
], ProfileService);

let DrawService = class DrawService extends BaseService {
    constructor(speViewNPrizeDrawProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.speViewNPrizeDrawProxy = speViewNPrizeDrawProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
    }
    findPromotionData(uuidWhiteLabel) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findPromotionData(uuidWhiteLabel)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findLastDraw(uuidWhiteLabel) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findLastDraw(uuidWhiteLabel)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findDrawsByPeriod(uuidWhiteLabel, period) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findDrawsByPeriod(uuidWhiteLabel, period)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findDrawsLastRegisters(uuidWhiteLabel, amount, period) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findDrawsLastRegisters(uuidWhiteLabel, amount, period)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findWinners(uuidWhiteLabel) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findWinners(uuidWhiteLabel)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findPromotionByID(uuidWhiteLabel, user_id) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findUserIdAndPromoUuid(uuidWhiteLabel, user_id)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findPromotionByUsername(uuidWhiteLabel, username) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findUserNameAndPromoUuid(uuidWhiteLabel, username)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findCupon(uuidWhiteLabel, user_id) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findCouponUseridAndUuidWhiteLabel(uuidWhiteLabel, user_id)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findCuponByID(uuidWhiteLabel, user_id, coupon_id) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findUserIdAndCouponIdAndUuidWhiteLabel(uuidWhiteLabel, user_id, coupon_id)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findBlacklistByCPF(uuidWhiteLabel, cpf) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findBlackListPerCpfAndUuidWl(uuidWhiteLabel, cpf)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findBlacklist(uuidWhiteLabel) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findBlackListPerUuidWl(uuidWhiteLabel)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findAwards(uuidWhiteLabel) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findAwardPerUuidWl(uuidWhiteLabel)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findLuckyNumbers(uuidWhiteLabel, user_id) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findLuckNumerPerUuidWlAndUserId(uuidWhiteLabel, user_id)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findLastLuckyNumber(uuidWhiteLabel, user_id) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findLastLuckyNumber(uuidWhiteLabel, user_id)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findFAQ(uuidWhiteLabel) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findFAQ(uuidWhiteLabel)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findTermsAndRegulations(uuidWhiteLabel) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findTermsAndRegulations(uuidWhiteLabel)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findPublications(uuidWhiteLabel) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findPublications(uuidWhiteLabel)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findPublicationsByPeriod(uuidWhiteLabel, period) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findPublicationsByPeriod(uuidWhiteLabel, period)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findPublicationsLastWinners(uuidWhiteLabel, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findPublicationsLastWinners(uuidWhiteLabel, amount)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findPublicationsLastDraws(uuidWhiteLabel, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findPublicationsLastDraws(uuidWhiteLabel, amount)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findPrivateContent(uuidWhiteLabel, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findPrivateContent(uuidWhiteLabel, amount)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findPublicationsPrizes(uuidWhiteLabel, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findPublicationsPrizes(uuidWhiteLabel, amount)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
    findPublicationsDraws(uuidWhiteLabel, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            let response;
            yield this.speViewNPrizeDrawProxy
                .findPublicationsLastWinners(uuidWhiteLabel, amount)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            if (!!consultResponse) {
                response = this.createBody(consultResponse);
            }
            else {
                response = null;
            }
            return Promise.resolve(response);
        });
    }
    createBody(list) {
        let body = [];
        list.forEach((element) => {
            const drawDate = new Date(element.drawDate);
            body.push({
                name: element.name,
                award: element.award,
                location: element.location,
                luckyNumber: element.luckyNumber,
                drawDate: element.drawDate,
                video: element.video,
                monthYear: drawDate.getMonth() + 1 + '-' + drawDate.getFullYear(),
            });
        });
        return body;
    }
};
DrawService.ctorParameters = () => [
    { type: SpeViewNPrizeDrawProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService }
];
DrawService = __decorate([
    Injectable()
], DrawService);

let WalletService = class WalletService extends BaseService {
    constructor(storage, formBuilder, configService, spePrizeDrawProxy, speViewNPrizeDrawProxy, errorMessageService) {
        super(storage, configService);
        this.storage = storage;
        this.formBuilder = formBuilder;
        this.configService = configService;
        this.spePrizeDrawProxy = spePrizeDrawProxy;
        this.speViewNPrizeDrawProxy = speViewNPrizeDrawProxy;
        this.errorMessageService = errorMessageService;
        this.planPaymentInfoErrorMessage = {
            cardNumber: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARD_NUMBER.REQUIRED' },
                { type: 'redundant', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARD_NUMBER.REDUNDANT' },
                { type: 'invalidcardbrand', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARD_NUMBER.INVALID_CARD_BRAND' },
                { type: 'invalidcard', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARD_NUMBER.INVALID_CARD' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARD_NUMBER.MIN_LENGTH',
                    param: {
                        minLength: 15,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARD_NUMBER.MAX_LENGTH',
                    param: {
                        maxLength: 16,
                    },
                },
            ],
            cardName: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARRIERS_NAME.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARRIERS_NAME.MIN_LENGTH',
                    param: {
                        minLength: 6,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARRIERS_NAME.MAX_LENGTH',
                    param: {
                        maxLength: 60,
                    },
                },
            ],
            validDate: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.VALID_THRU.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.VALID_THRU.MIN_LENGTH',
                    param: {
                        minLength: 4,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.VALID_THRU.MAX_LENGTH',
                    param: {
                        maxLength: 4,
                    },
                },
                { type: 'validThru', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.VALID_THRU.DATE_INVALID' },
            ],
            cardCode: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CVV.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CVV.MIN_LENGTH',
                    param: {
                        minLength: 3,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CVV.MAX_LENGTH',
                    param: {
                        maxLength: 4,
                    },
                },
            ],
        };
    }
    getFormPaymentInfo() {
        this.formPaymentInfo = this.formBuilder.group({
            cardNumber: new FormControl('', Validators.compose([Validators.required, Validators.minLength(17), Validators.maxLength(19)])),
            cardName: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(60)])),
            validDate: new FormControl('', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5), validateDate])),
            cardCode: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])),
            flagCard: new FormControl('', Validators.compose([Validators.required])),
        });
        return this.formPaymentInfo;
    }
    getFormPlanPaymentInfoErrorMessage() {
        return this.planPaymentInfoErrorMessage;
    }
    getWallets(uuidWhiteLabel, uuidAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.spePrizeDrawProxy
                .getWallets(uuidWhiteLabel, uuidAccount)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findTransactions(uuidAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findTransactions(uuidAccount)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findTransactionsByPeriod(uuidAccount, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findTransactionsByPeriod(uuidAccount, startDate, endDate)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
};
WalletService.ctorParameters = () => [
    { type: Storage },
    { type: FormBuilder },
    { type: ConfigService },
    { type: SpeViewNAccountProxy },
    { type: SpeViewNPrizeDrawProxy },
    { type: ErrorMessageService }
];
WalletService = __decorate([
    Injectable()
], WalletService);
function validateDate(control) {
    let validThru = control.value;
    let arryDate = validThru.split('/');
    let currencyDate = new Date();
    if (Number(arryDate[0]) >= 1 && Number(arryDate[0]) <= 12) {
        if (Number(arryDate[1]) === currencyDate.getFullYear() - 2000) {
            if (Number(arryDate[0]) >= currencyDate.getMonth() + 1) {
                return null;
            }
            else {
                return { validThru: true };
            }
        }
        else if (Number(arryDate[1]) >= currencyDate.getFullYear() - 2000) {
            return null;
        }
        else {
            return { validThru: true };
        }
    }
    else
        return { validThru: true };
}

class UserSupportResponse {
}

let SupportService = class SupportService extends BaseService {
    constructor(speNPrizeDrawProxy, speViewNPrizeDrawProxy, speJNotificationProxy, formBuilder, storage, configService, errorMessageService) {
        super(storage, configService);
        this.speNPrizeDrawProxy = speNPrizeDrawProxy;
        this.speViewNPrizeDrawProxy = speViewNPrizeDrawProxy;
        this.speJNotificationProxy = speJNotificationProxy;
        this.formBuilder = formBuilder;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorMessagesTalkToUs = {
            fullName: [
                { type: 'required', message: 'PRIZE_DRAW.TALK-TO-US.INPUT.FULLNAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'PRIZE_DRAW.TALK-TO-US.INPUT.FULLNAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'PRIZE_DRAW.TALK-TO-US.INPUT.FULLNAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 },
                },
            ],
            email: [
                { type: 'required', message: 'PRIZE_DRAW.TALK-TO-US.INPUT.E-MAIL.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'PRIZE_DRAW.TALK-TO-US.INPUT.E-MAIL.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'PRIZE_DRAW.TALK-TO-US.INPUT.E-MAIL.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 },
                },
                { type: 'pattern', message: 'PRIZE_DRAW.TALK-TO-US.INPUT.E-MAIL.MESSAGE.PATTERN' },
                { type: 'email', message: 'PRIZE_DRAW.TALK-TO-US.INPUT.E-MAIL.MESSAGE.PATTERN' },
                { type: 'redundant', message: 'PRIZE_DRAW.TALK-TO-US.INPUT.E-MAIL.MESSAGE.REDUNDANT' },
            ],
            topic: [{ type: 'required', message: 'PRIZE_DRAW.TALK-TO-US.INPUT.TOPIC.MESSAGE.REQUIRED' }],
            message: [
                { type: 'required', message: 'PRIZE_DRAW.TALK-TO-US.INPUT.MESSAGE.REQUIRED' },
            ],
        };
    }
    getFormPrizeDrawTalkToUs() {
        this.formPrizeDrawTalkToUs = this.formBuilder.group({
            fullName: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(100)])),
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
                Validators.email,
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}'),
            ])),
            topic: new FormControl('', Validators.compose([Validators.required])),
            message: new FormControl('', Validators.compose([
                Validators.required,
            ])),
        });
        return this.formPrizeDrawTalkToUs;
    }
    getFormMessageTalkToUs() {
        return this.errorMessagesTalkToUs;
    }
    // Terminar
    findUserSupport(uuidWhiteLabel, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findUserIdAndPromoUuid(uuidWhiteLabel, userId)
                .toPromise()
                .then((res) => {
                consultResponse = res[0];
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    saveData(form, user_id, uuidWhiteLabel) {
        //return this.registerSupport(uuidWhiteLabel, this.setData(form, user_id));
        return this.sendEmail(uuidWhiteLabel, this.setData(form, user_id));
    }
    setData(form, user_id) {
        const supportBody = new UserSupportResponse();
        const data = form.getRawValue();
        supportBody.user_from_id = user_id;
        supportBody.parent_id = 1;
        supportBody.user_to_id = 1;
        supportBody.source_id = 1;
        supportBody.assunto = data.topic;
        supportBody.title = data.topic;
        supportBody.content = data.message;
        supportBody.private = 0;
        supportBody.status = 0;
        supportBody.tipo = 'SUPORTE';
        return supportBody;
    }
    updateSupport(uuidWhiteLabel, supportBody) {
        return this.speNPrizeDrawProxy.updateSupport(uuidWhiteLabel, supportBody);
    }
    registerSupport(uuidWhiteLabel, supportBody) {
        return this.speNPrizeDrawProxy.registerSupport(uuidWhiteLabel, supportBody);
        // SendGrid.setApiKey("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")
        // const msg = {
        //   to: 'diego.ferreira@techsavvy.com.br', // Change to your recipient
        //   from: 'no-reply.logbank@secure.srv.br', // Change to your verified sender
        //   subject: 'Suporte',
        //   html: supportBody,
        // }
        // return SendGrid.send(msg);
    }
    sendEmail(uuidWhiteLabel, supportBody) {
        const msg = `TIPO: ${String(supportBody.tipo).toUpperCase()}\n
    ASSUNTO: ${String(supportBody.title).toUpperCase()}\n
    CLIENTE CÓD: ${supportBody.user_from_id}\n
    \n
    MENSAGEM: ${supportBody.content}`;
        const message = {
            sendMessage: {
                replyTo: '',
                to: ['atendimento@premiadao.com.br'],
                cc: [],
                bcc: [],
                subject: `APP PREMIADÃO: ${String(supportBody.tipo).toUpperCase()} - ${String(supportBody.title).toUpperCase()} - Cliente: ${supportBody.user_from_id}`,
                text: msg,
            },
            type: TypeEmailEnum.SIMPLE,
            uuidWhiteLabel: uuidWhiteLabel,
            typeTemplate: TypeTemplateEnum.CUSTOM,
            mapParam: {},
        };
        return this.speJNotificationProxy.sendEmail(message);
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
};
SupportService.ctorParameters = () => [
    { type: SpeNPrizeDrawProxy },
    { type: SpeViewNPrizeDrawProxy },
    { type: SpeJNotificationProxy },
    { type: FormBuilder },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService }
];
SupportService = __decorate([
    Injectable()
], SupportService);

let PaymentService = class PaymentService extends BaseService {
    constructor(storage, configService, speViewNAccountProxy, speViewNPrizeDrawProxy, speNPrizeDrawProxy, speNUserAccountProxy, speViewNUserAccountProxy, errorMessageService, SpeJOrderCommerce) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.speViewNAccountProxy = speViewNAccountProxy;
        this.speViewNPrizeDrawProxy = speViewNPrizeDrawProxy;
        this.speNPrizeDrawProxy = speNPrizeDrawProxy;
        this.speNUserAccountProxy = speNUserAccountProxy;
        this.speViewNUserAccountProxy = speViewNUserAccountProxy;
        this.errorMessageService = errorMessageService;
        this.SpeJOrderCommerce = SpeJOrderCommerce;
    }
    getWallets(uuidWhiteLabel, uuidAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNAccountProxy
                .getWallets(uuidWhiteLabel, uuidAccount)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findTransactions(uuidAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findTransactions(uuidAccount)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findPreAccount(uuidWhiteLabel, uuidAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNUserAccountProxy
                .findPreUserAccount(uuidWhiteLabel, uuidAccount)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    updateRecurrence(id, recurrent) {
        return this.speNUserAccountProxy.updateRecurrence(id, recurrent);
    }
    findPayments(uuidOrderCommerce, uuidAccountPaymentSeller, uuidWhiteLabelSeller) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findPayments(uuidOrderCommerce, uuidAccountPaymentSeller, uuidWhiteLabelSeller)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    findOrders(uuidWhiteLabel, user_id) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speViewNPrizeDrawProxy
                .findOrders(uuidWhiteLabel, user_id)
                .toPromise()
                .then((res) => {
                consultResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    makeThePayment(paymentData) {
        return __awaiter(this, void 0, void 0, function* () {
            let validateResponse;
            const paymentBody = {
                orderId: paymentData.orderId ? paymentData.orderId : null,
                uuidWhiteLabel: paymentData.uuidWhiteLabel,
                uuidAccountPaymentCustomer: paymentData.uuidAccountPaymentCustomer,
                uuidAccountPaymentWallet: paymentData.uuidAccountPaymentWallet ? paymentData.uuidAccountPaymentWallet : null,
                installments: paymentData.installments ? paymentData.installments : 1,
                items: [
                    {
                        id: '0001',
                        description: paymentData.description ? paymentData.description : 'Sorteio Rodada ',
                        amount: paymentData.amount,
                    },
                ],
                transactionType: paymentData.transactionType,
                recurrentInterval: paymentData.recurrentInterval,
                customData: {
                    uuidSSO: paymentData.uuidSSO,
                    prizeDrawID: paymentData.prizeDrawID,
                    prizeOrderId: paymentData.prizeOrderId,
                },
            };
            yield this.speNPrizeDrawProxy
                .makeThePayment(paymentBody)
                .toPromise()
                .then((res) => {
                validateResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
    getOrderCommerce(uuidOrderCommerce) {
        return this.SpeJOrderCommerce.findByUuid(uuidOrderCommerce);
    }
    getOrderCommerceWithPayment(uuidOrderCommerce) {
        return this.SpeJOrderCommerce.findByUuidWithPayment(uuidOrderCommerce);
    }
    checkRecurrence(uuidAccountPayment) {
        return this.speViewNPrizeDrawProxy.checkRecurrence(uuidAccountPayment);
    }
    checkPurchaseAtLastWeek(uuidAccountPayment) {
        return this.speNPrizeDrawProxy.checkPurchaseAtLastWeek(uuidAccountPayment);
    }
};
PaymentService.ctorParameters = () => [
    { type: Storage },
    { type: ConfigService },
    { type: SpeViewNAccountProxy },
    { type: SpeViewNPrizeDrawProxy },
    { type: SpeNPrizeDrawProxy },
    { type: SpeNUserAccountProxy },
    { type: SpeViewNUserAccountProxy },
    { type: ErrorMessageService },
    { type: SpeJOrderCommerce }
];
PaymentService = __decorate([
    Injectable()
], PaymentService);

let UiBsPrizeDrawModule = class UiBsPrizeDrawModule {
};
UiBsPrizeDrawModule = __decorate([
    NgModule({
        declarations: [],
        imports: [UiPxPrizeDrawModule, UiBsUtilModule],
        providers: [
            LoginService,
            RegisterService,
            ProfileService,
            DrawService,
            WalletService,
            SupportService,
            PaymentService,
        ],
    })
], UiBsPrizeDrawModule);

/*
 * Public API Surface of ui-bs-prizedraw
 */

/*
 * Public API Surface of ui-bs-prizedraw
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomData, DrawService, ItemPayment, LoginService, PaymentResponse, PaymentService, PrizeDrawAddressResponse, PrizeDrawPassWordResponse, PrizeDrawRegisterResponse, PrizeDrawSignupResponse, ProfileService, Recurrent, RegisterService, SupportService, UiBsPrizeDrawModule, WalletService, validateDate };
//# sourceMappingURL=wlp-ui-bs-prizedraw.js.map
